/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NewsManagementShowNewsResponse } from './NewsManagementShowNewsResponse';

export type NewsManagementShowNewsResponseApiRespoonse = {
    data?: NewsManagementShowNewsResponse;
    status?: NewsManagementShowNewsResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace NewsManagementShowNewsResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

